import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/components/feature/PostCard";
import { posts } from "@/mocks/posts";
import HeroSection from "./components/HeroSection";
import TickerBar from "./components/TickerBar";
import StatBand from "./components/StatBand";
import FeaturedStory from "./components/FeaturedStory";
import HotRankPanel from "./components/HotRankPanel";
import TopicCloud from "./components/TopicCloud";
import EditorPanel from "./components/EditorPanel";
import CategorySection from "./components/CategorySection";
import LeakForm from "./components/LeakForm";

export default function Home() {
  const featured = posts[0];
  const feed = posts.slice(1);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <TickerBar />
        <StatBand />

        <section className="w-full px-4 md:px-8 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
            <div className="lg:col-span-8">
              <SectionHeading
                eyebrow="今日头条"
                title="正在发生的这口瓜"
                action={
                  <Link
                    to="/rank"
                    className="hidden sm:inline-flex items-center gap-1.5 rounded-md border border-background-300/70 px-3.5 py-2 text-sm font-medium text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-400 hover:text-primary-600"
                  >
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    看完整热榜
                  </Link>
                }
              />
              <FeaturedStory post={featured} />

              <div className="mt-12">
                <SectionHeading
                  eyebrow="持续更新"
                  title="最新吃瓜看料"
                  description="编辑部 7×24 小时盯着全网，新瓜一出立刻上架。"
                />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
                  {feed.map((post) => (
                    <PostCard key={post.id} post={post} />
                  ))}
                </div>
              </div>
            </div>

            <aside className="lg:col-span-4 space-y-6">
              <HotRankPanel />
              <TopicCloud />
              <EditorPanel />
            </aside>
          </div>
        </section>

        <CategorySection />
        <LeakForm />
      </main>
      <SiteFooter />
    </div>
  );
}